// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"42":"98eb1790","472":"b94b2ff0","895":"af48a2e4","940":"c7028d95","968":"cd05b5ab"}[chunkId] + ".js";
};